import React from 'react'
import { AccountKYCForm } from '../shared/AccountKYCForm'

export const CreateAccountKYC = () => {
  return <AccountKYCForm successPath="/create-account/success" />
}
